import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import FormikInputField from '../../../../app/components/formikComponents/FormikInputField';
import PortletBody from '../../../../app/components/portlet/PortletBody';
import StyledButton from '../../../../app/components/styledComponents/StyledButton';
import { Wrap } from '../../../../assets/styledComponents/Global';
import theme from '../../../../utils/themes';
import { StyledLabel } from '../../../Campaigns/CampaignDetails';
import {
  deductCreditsValidationSchema,
} from '../assets/companyCreationUtill';

const DeductCreditsModal = ({ show, hide, onHide, compId, apiCall, deductLoading }) => {
  const handleSubmit = (values) => {
    const occyCredit = {
      creditsToDeduct: values?.occyCredits,
      comment: values?.comment || undefined,
      companyId: compId
    };

    apiCall(occyCredit);
  };
  return (
    <Modal show={show} centered onHide={onHide} size={'lg'}>
      <Modal.Header
        closeButton
        className="border-bottom-0 pb-0 align-items-baseline"
      >
        <div>
          <Modal.Title
            as="h4"
            className="flex-grow-1 px-0 cursor-pointer flex-center fs-3 ps-2 pb-3 font-fredoka fw-normal"
          >
            Deduct Credits
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="d-flex  flex-column bg-body rounded">
    <Formik
    initialValues={{ occyCredits: '',
  comment: '',}}
      validationSchema={deductCreditsValidationSchema}
      //   validate={validate}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <PortletBody>
            <Wrap>
              <StyledLabel className="mb-1">Quantity</StyledLabel>
              <FormikInputField
                id="occyCredits"
                name="occyCredits"
                type="number"
                label="Credits"
                placeholder="Enter quantity"
              />
            </Wrap>
            <Wrap className="mt-3">
              <Wrap className='d-flex gap-1'>
                <StyledLabel className="mb-1">
                  Add a comment
                </StyledLabel>
                <StyledLabel className="mb-1" color={theme.inputColor}>
                  (optional - visible to client)
                </StyledLabel>
              </Wrap>
              <FormikInputField
                id="comment"
                name="comment"
                placeholder="Add a short comment for future reference"
              />
            </Wrap>
          </PortletBody>
          <div className="d-flex justify-content-end mt-3">
            <StyledButton
              className="mb-2 border-0 fw-bold"
              onClick={onHide}
              variant="text"
            >
              Cancel
            </StyledButton>
            <StyledButton
              className="mb-2 border-0 fw-bold"
              type="submit"
              disabled={deductLoading}
              loading={deductLoading}
            >
              Save Changes
            </StyledButton>
          </div>
        </Form>
      )}
    </Formik>
    </Modal.Body>
        </Modal>
    
  );
};


export default DeductCreditsModal;
